<template>
  <q-dialog ref="reportModal" @hide="onDialogHide">
    <q-card class="bg-white" id="report-modal-card">
      <q-toolbar class="row full-width justify-between bg-primary">
        <div class="q-toolbar-title">
          {{$t('report.generate_report.reportmodal')}}
        </div>
        <q-btn class="pull-right" flat @click="$refs.reportModal.hide()" data-cy="report-modal-btn-close">
          <q-icon name="close"/>
        </q-btn>
      </q-toolbar>
      <q-card-section class="q-pt-lg">
        <q-inner-loading :showing="loading"/>
        <q-banner class="col-12 bg-warning"
                  v-if="noTemplates && !loading">
          <q-icon name="warning"/>
          {{$t('report.no_templates.reportmodal')}}
        </q-banner>

        <q-input float-label :label="$t('report.filename.reportmodal')" v-model="file" data-cy="report-modal-input-filename"/>

        <q-select
          v-model="template"
          v-if="templates.length > 0"
          float-label
          map-options
          emit-value
          :label="$t('report.templates.reportmodal')"
          :options="templates"
          data-cy="report-modal-select-template"/>

        <q-select
          v-model="folder"
          float-label
          map-options
          emit-value
          :label="$t('report.folder.reportmodal')"
          :options="folders"
          data-cy="report-modal-select-folder"/>

        <div class="col-12" data-cy="report-modal-text-confirm">
          {{$t('report.generate_confirm.reportmodal', {name: fullName, item: $t('report.report.reportmodal')})}}
        </div>

      </q-card-section>

      <q-card-actions class="row justify-end xs-gutter modal-body">
        <div class="col"></div>
        <div class="col-auto">
          <q-btn flat color="black" @click="onCancelClick" data-cy="report-modal-btn-back">{{$t('report.back.reportmodal')}}</q-btn>
        </div>
        <div class="col-auto">
          <q-btn color="primary" :loading="buttonLoader" class="col-auto" :disabled="noTemplates || !folder || !template"
                 @click="onOKClick" data-cy="report-modal-btn-confirm">
            {{$t('report.confirm.reportmodal')}}
          </q-btn>
        </div>
      </q-card-actions>

    </q-card>
  </q-dialog>
</template>

<script>
  import {
    QBanner,
    QBtn,
    QCard,
    QCardActions,
    QCardSection,
    QDialog,
    QIcon,
    QInnerLoading,
    QInput,
    QSelect,
    QToolbar,
  } from 'quasar'
  import { dateUtils } from '@parantion/components'
  import { getReportDefaultFileName } from '@/services/APIService';

  const { dateFormat } = dateUtils

  export default {
    name: 'report-modal',
    components: {
      QDialog,
      QBtn,
      QSelect,
      QToolbar,
      QIcon,
      QInput,
      QBanner,
      QCard,
      QCardSection,
      QCardActions,
      QInnerLoading
    },
    props: ['student', 'form'],
    data () {
      return {
        output: '',
        folder: '',
        template: '',
        file: '',
        buttonLoader: false,
        typeOptions: [{
          label: 'PDF',
          value: 'pdf'
        }],
        loading: true,
        templates: []
      }
    },
    watch: {
      templates (templates) {
        if (templates.length > 0) this.template = templates[0].value
      },
      template () {
        this.retrieveFilename()
      }
    },
    methods: {
      onDialogHide() {
        this.buttonLoader = false
        this.templates = []
      },
      hide() {
        this.$emit('hide')
      },
      onCancelClick() {
        this.hide()
      },
      async show () {
        this.$refs.reportModal.show()
        this.output = 'pdf'
        this.folder = 'all_reports'
        this.loading = true;
        try {
          this.templates = await this.$store.dispatch('base/fetchReportTemplates', { fh: this.form.fh, parent: this.form.tn })
                  .then(templates => {
                    return templates.map(t => ({
                      label: t.label,
                      value: t.tn
                    })).sort((a, b) => {
                      const x = a.label.toLowerCase()
                      const y = b.label.toLowerCase()
                      return x < y ? -1 : x > y ? 1 : 0
                    })
                  })
        } catch (e) {
          console.error(e)
          this.$toasty.error('Er is iets misgegaan. Probeer het later nog eens.')
        } finally {
          this.loading = false
        }
      },
      onOKClick () {
        this.buttonLoader = true
        const folderHash = (this.storeFolders.find(folder => folder.OrigName === this.folder)).Id
        if (!folderHash) {
          this.buttonLoader = false
          return
        }

        this.$store.dispatch('base/generateReport', {
          fh: this.form.fh,
          folderHash,
          uh: this.student.uh,
          fileName: this.file,
          outputFormat: this.output,
          tn: this.template
        })
        .catch(() => {
          this.$toasty.error(this.$t('report.generate_report_error.errorlbl'))
        })

        this.$root.$emit('addJob', {
          folderHash,
          uh: this.student.uh,
          reportLabel: this.file
        })

        setTimeout(() => {
          this.$emit('ok')
          this.hide()
          this.buttonLoader = false
        }, 400)
      },
      async retrieveFilename () {
        const fileName = await getReportDefaultFileName(this.form.fh, this.template)
        if (fileName) this.file = fileName
        else if (this.file === '') {
          const timeStamp = new Date()
          const formattedString = dateFormat(timeStamp, 'dd-MM-yyyy')
          this.file = `Groeidocument van ${this.student.firstname || ''} ${this.student.middlename || ''} ${this.student.lastname || ''} (${formattedString})`.replace(/\s+/g, ' ')
        }
      }
    },
    computed: {
      noTemplates () {
        return this.templates.length === 0
      },
      fullName () {
        return `${this.student.firstname + ' '}${this.student.middlename ? this.student.middlename + ' ' : ''}${this.student.lastname}`
      },
      storeFolders () {
        if (!this.$store.state.parantion.newfiles.uid) return []
        else return this.$store.state.parantion.newfiles.folders.filter(folder => !folder.Shared || (folder.Shared && folder.SharedWritable))
      },
      folders () {
        return this.storeFolders.map(f => ({
          label: this.$t(f.Name),
          value: f.OrigName
        }))
      }
    }
  }
</script>

<style lang="stylus" scoped>
  /* {minWidth: '70vw', maxWidth: '70vw', minHeight: '20vh'} */
  #report-modal-card {
    min-width 70vw
    max-width 70vw
    min-height 20vh
  }
</style>
